import React from 'react';
const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/24zfP7KkxSFDLBnMcURiVU/logoYD.webp';
interface LogoProps {
  /** 'md' → header · 'lg' → footer */
  size?: 'md' | 'lg';
  className?: string;
}

/**
 * Logo oficial de YenniDigital.
 * El marco recorta el margen vertical del archivo sin deformar la imagen (object-cover, proporción original intacta).
 */
export function Logo({
  size = 'md',
  className = ''
}: LogoProps) {
  const width = size === 'lg' ? 'w-[190px] sm:w-[220px]' : 'w-[140px] sm:w-[160px] lg:w-[180px]';
  return <a href="#inicio" aria-label="YenniDigital — Inicio" className={`inline-flex shrink-0 items-center transition-opacity duration-200 ease-out hover:opacity-90 ${className}`} data-id="element-178" data-mp="rpuwsijgt65z">
      <span className={`relative block overflow-hidden ${width}`} style={{
      aspectRatio: '2.6 / 1'
    }} data-id="element-179" data-mp="hvuj3sa4asln">
        <img src={LOGO_SRC} alt="YenniDigital — Digital Marketing Agency" className="absolute inset-0 h-full w-full object-cover object-center" loading="eager" decoding="async" data-id="element-180" data-mp="2ykhtna21rc5i" />
      </span>
    </a>;
}